// Marketing homepage — section composer.
// Sections are built and validated incrementally on staging before promoting to prod.
// Source canonical: design-system/project/homepage/index.html
import { useEffect } from 'react';
import './landing.css';
import Nav from './sections/Nav';
import Hero from './sections/Hero';
import Roster from './sections/Roster';
import HowItWorks from './sections/HowItWorks';
import Roadmap from './sections/Roadmap';
import Waitlist from './sections/Waitlist';
import Footer from './sections/Footer';

export default function Landing() {
  // Marketing site is dark-only; ensure body bg matches in case the theme attribute hasn't applied yet.
  useEffect(() => {
    document.body.style.background = '#1A1918';
    return () => { document.body.style.background = ''; };
  }, []);

  return (
    <div className="landing-root">
      <Nav />
      <Hero />
      <Roster />
      <HowItWorks />
      <Roadmap />
      <Waitlist />
      <Footer />
    </div>
  );
}
